import { useParams } from 'react-router-dom'

import { CustomComponentData } from '@/components/CustomComponent/CodeEditor'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { CustomComponentEnhanced } from '@/screens/ComponentLibrary/hooks/CONSTANTS'

export type ConfigDataProps = {
  parseConfig: (
    param?: CustomComponentEnhanced<CustomComponentData>
  ) => Record<string, unknown>
  label: string
}
export default function ConfigData({ parseConfig, label }: ConfigDataProps) {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent(componentID)
  const config = current.data ? parseConfig(current.data) : {}
  const valid = useValidateEndpoint(config, componentID)

  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName={label}
      valid={valid}
    />
  )
}
